/* eslint-disable */
import {
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import Item from "../../utils/Item";
import PrecioVentaContadoLista from "./PrecioVentaContadoLista";
import { formatEsferaCilindroAdicion } from "../../utils/utils";

//
// ###########################################################################
//
const DatosLenteContacto = ({ articulo, showPrecio = true }) => {

  //
  // ################################################################################
  //
  return (
    <>
      {articulo && (
        <>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                Lente de Contacto
              </Typography>

              <Grid container spacing={2}>
                <Item label="Producto" value={articulo.descripcion_lente_contacto_producto} />
                <Item label="Descripción" value={articulo.descripcion} />
                <Item label="Modelo" value={articulo.modelo} />
                <Item label="Marca" value={articulo.descripcion_lc_marca} />
                <Item label="Submarca" value={articulo.descripcion_lc_submarca} />
                <Item label="Material" value={articulo.descripcion_lc_material} />
                <Item label="Tipo" value={articulo.descripcion_lc_tipo} />
                <Item label="Color" value={articulo.descripcion_lc_color} />
                <Item label="Diagnóstico  " value={articulo.descripcion_lc_diagnostico} />
                <Item label="Presentación" value={articulo.descripcion_lc_presentacion} />
                <Item label="Tiempo de uso" value={articulo.descripcion_lc_tiempo_uso} />
                <Item label="Esfera" value={formatEsferaCilindroAdicion(articulo.esfera)} />
                <Item label="Cilindro" value={formatEsferaCilindroAdicion(articulo.cilindro)} />
                <Item label="Eje" value={articulo.eje} />
              </Grid>
            </CardContent>
          </Card>

          {showPrecio && (
            <Card sx={{ mt: 2 }}>
              <CardContent>
                <PrecioVentaContadoLista precioVentaContado={articulo.precio_venta_contado} precioVentaLista={articulo.precio_venta_lista} />
              </CardContent>
            </Card>
          )}
        </>
      )}
    </>
  );
};
export default DatosLenteContacto;
